import { render, staticRenderFns } from "./RewardProducts.vue?vue&type=template&id=2ae1d6a7&scoped=true"
import script from "./RewardProducts.vue?vue&type=script&lang=js"
export * from "./RewardProducts.vue?vue&type=script&lang=js"
import style0 from "./RewardProducts.vue?vue&type=style&index=0&id=2ae1d6a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1d6a7",
  null
  
)

export default component.exports